import { Resources } from 'constants/resources';

import { maxValue, minValue, ReferenceInput, required } from 'react-admin';
import { Row } from 'shared/mui/Row/Row';
import { AutocompleteInput, NumberInput } from 'shared/react-admin/Inputs';

type Props = {
  providerId: string | undefined;
  merchantId: string | undefined;
};

export type MerchantsShowSettingsFormValues = {
  merchant: string;
  provider: string;
  merchantAccount: string;
  percent: number | null;
};

const VALIDATE_ERROR_MESSAGE = 'Значение должно быть от 0 до 100 включительно';

export const MerchantsShowSettingsForm = ({ providerId, merchantId }: Props) => {
  const isInteger = (value: number | undefined): string | undefined =>
    value !== undefined && !Number.isInteger(Number(value)) ? VALIDATE_ERROR_MESSAGE : undefined;

  return (
    <>
      <Row marginBottom={3}>
        <ReferenceInput reference={Resources.Merchants} source="merchant">
          <AutocompleteInput
            helperText={false}
            label="Мерчант"
            optionText="name"
            readOnly
            variant="outlined"
          />
        </ReferenceInput>
        <ReferenceInput reference={Resources.Providers} source="provider">
          <AutocompleteInput
            helperText={false}
            label="Провайдер"
            optionText="name"
            readOnly
            variant="outlined"
          />
        </ReferenceInput>
      </Row>
      <Row>
        <ReferenceInput
          filter={{
            merchants: merchantId,
            provider: providerId,
          }}
          isRequired={true}
          reference={Resources.MerchantAccounts}
          source="merchantAccount"
        >
          <AutocompleteInput
            helperText={false}
            label="Счёт мерчанта"
            optionText="name"
            validate={required()}
            variant="outlined"
          />
        </ReferenceInput>
        <NumberInput
          helperText={false}
          label="Процент"
          source="percent"
          step={1}
          validate={[
            minValue(0, VALIDATE_ERROR_MESSAGE),
            maxValue(100, VALIDATE_ERROR_MESSAGE),
            isInteger,
          ]}
          variant="outlined"
        />
      </Row>
    </>
  );
};
